
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g_45BrQbKJx_45q1mP1QsTqn7BU_hE5V28NiNrejWR962BekMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexTJDgcjoDF_Hv5THqBqevl7gwD5uFXOGejlmkUa_R2SQMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchUybUs0jk8UPfgtdn37B5mVjOCQJdGwhcmNCuQKjxTWoMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexIfbo6eNBtu9NgMRM6__k4kyUFgd6_RJxh6StgxjYlLwMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_931DzjqAdCDFDhIIHIZcbJNHQe3Y2HBhvQsWp_LV8YM7MMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexjG4Ck4GJ8ishW5KxuTFW9fQdIIz4QV0XfB_4513O47Bd0Meta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93oCZj7ggE4xIEzALKdKLupsKD0FiQnhVeYX9pcgExVIsMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexbS2ZPg0V23QLm6ssrfXP1mlCmu37LtdNCYk9mor82U4Meta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93VkYUTRiWFylpCwavBUVCVpw7Q6T3FF8Nxs5uvoLWlBoMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexH1J192IPSSJFk5xHCrZ_45TU_ivPW6QFj9ci2KFI9ajukMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexi1KiQH_45GDucpc7ujdQ53NUGGjUInrpS81dNmySnBLnkMeta } from "/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexjG4Ck4GJ8ishW5KxuTFW9fQdIIz4QV0XfB_4513O47Bd0Meta || {},
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexbS2ZPg0V23QLm6ssrfXP1mlCmu37LtdNCYk9mor82U4Meta || {},
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexH1J192IPSSJFk5xHCrZ_45TU_ivPW6QFj9ci2KFI9ajukMeta || {},
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexi1KiQH_45GDucpc7ujdQ53NUGGjUInrpS81dNmySnBLnkMeta || {},
    component: () => import("/codebuild/output/src3087716633/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]